import { Card, CardContent } from '@components/card';
import { CreateBenchUserForm } from '@components/forms/staff/benchUsers/create';
import { BaseLayout } from '@layouts/base';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function NewBenchUser() {
  const { t } = useTranslation('app');

  return (
    <BaseLayout isChild title={t('pages.newBenchUser.title')}>
      <Card>
        <CardContent className="p-6">
          <CreateBenchUserForm />
        </CardContent>
      </Card>
    </BaseLayout>
  );
}

export const Route = createFileRoute('/u/$localId/_staff/staff/bench-users/new')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['bench_users_create'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: NewBenchUser,
});
